<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { spell_checker_enabled } = currentAccount.value?.settings || {};
    isEnabled.value = !!spell_checker_enabled;
  },
  { deep: true, immediate: true }
);

const updateAccountSettings = async settings => {
  try {
    await updateAccount(settings);
    useAlert(t('GENERAL_SETTINGS.FORM.SPELL_CHECKER.API.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.SPELL_CHECKER.API.ERROR'));
  }
};

const toggleSpellChecker = async () => {
  return updateAccountSettings({
    spell_checker_enabled: isEnabled.value,
  });
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.SPELL_CHECKER.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.SPELL_CHECKER.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleSpellChecker" />
      </div>
    </template>
  </SectionLayout>
</template>
